import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../../shared';
import {InquiryHeaderContainerModel} from '../../../../../../models/aggregates/erp/inquiry';
import {Core2Config} from '../../shared';


@Injectable({
  providedIn: 'root'
})
export class InquiryHdrService extends BaseApiTemplateService<InquiryHeaderContainerModel> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.DOMAIN_URL_PREFIX + 'inquiries-hdrs';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.DOMAIN_URL_PREFIX + 'inquiries-hdrs';
    this.endpoint_path = Core2Config.DOMAIN_URL_PREFIX + 'inquiries-hdrs';
    this.httpClient = http;
  }

}


